import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class VatStatement  {
    _originalTypeClassName = "zERP.BO.VatStatement";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
VatStatement.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Field003 = null;
this.Field004 = null;
this.Field005 = null;
this.Field006 = null;
this.Field007 = null;
this.Field008 = null;
this.Field009 = null;
this.Field101 = null;
this.Field102 = null;
this.Field103 = null;
this.Field104 = null;
this.Field301 = null;
this.Field302 = null;
this.Field303 = null;
this.Field304 = null;
this.Field305 = null;
this.Field306 = null;
this.Field307 = null;
this.Field310 = null;
this.Field311 = null;
this.Field312 = null;
this.Field331 = null;
this.Field332 = null;
this.Field333 = null;
this.Field334 = null;
this.Field335 = null;
this.Field336 = null;
this.Field337 = null;
this.Field342 = null;
this.Field345 = null;
this.Field348 = null;
this.Field349 = null;
this.Field361 = null;
this.Field362 = null;
this.Field363 = null;
this.Field364 = null;
this.Field365 = null;
this.Field366 = null;
this.Field367 = null;
this.Field381 = null;
this.Field382 = null;
this.Field383 = null;
this.Field384 = null;
this.Field385 = null;
this.Field386 = null;
this.Field387 = null;
this.Field400 = null;
this.Field401 = null;
this.Field402 = null;
this.Field403 = null;
this.Field404 = null;
this.Field407 = null;
this.Field410 = null;
this.Field411 = null;
this.Field422 = null;
this.Field423 = null;
this.Field428 = null;
this.Field430 = null;
this.Field470 = null;
this.Field480 = null;
this.Field483 = null;
this.Field502 = null;
this.Field503 = null;
this.Field507 = null;
this.Field508 = null;
this.Field511 = null;
this.Field523 = null;
this.Field906 = null;
this.Field907 = null;
this.Field908 = null;
this.StartDate = null;
this.EndDate = null;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Field003:any;
Field004:any;
Field005:any;
Field006:any;
Field007:any;
Field008:any;
Field009:any;
Field101:any;
Field102:any;
Field103:any;
Field104:any;
Field301:any;
Field302:any;
Field303:any;
Field304:any;
Field305:any;
Field306:any;
Field307:any;
Field310:any;
Field311:any;
Field312:any;
Field331:any;
Field332:any;
Field333:any;
Field334:any;
Field335:any;
Field336:any;
Field337:any;
Field342:any;
Field345:any;
Field348:any;
Field349:any;
Field361:any;
Field362:any;
Field363:any;
Field364:any;
Field365:any;
Field366:any;
Field367:any;
Field381:any;
Field382:any;
Field383:any;
Field384:any;
Field385:any;
Field386:any;
Field387:any;
Field400:any;
Field401:any;
Field402:any;
Field403:any;
Field404:any;
Field407:any;
Field410:any;
Field411:any;
Field422:any;
Field423:any;
Field428:any;
Field430:any;
Field470:any;
Field480:any;
Field483:any;
Field502:any;
Field503:any;
Field507:any;
Field508:any;
Field511:any;
Field523:any;
Field906:any;
Field907:any;
Field908:any;
StartDate:any;
EndDate:any;
Status:any;
Year:any;
Entity:any;
static setYear = ($this, value) => {
var oldValue = $this.Year;
$this.Year = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}

static GetMatches(invoice: any,mappings: any,fieldName: any): any{let relevantInvoicesRows = [];
if (mappings?.linq?.any((l) => CLMS.Framework.Number.Equal(() => l.FieldName, () => fieldName))) {let fieldMappings = mappings?.linq?.where((l) => CLMS.Framework.Number.Equal(() => l.FieldName, () => fieldName))?.toArray();for (let _ifMapping = 0; _ifMapping < (fieldMappings == null ? 0 : fieldMappings.length); _ifMapping++) {let fMapping = fieldMappings[_ifMapping];if (!(fMapping?.InvoiceTypes?.linq?.contains(invoice?.InvoiceHeader?.InvoiceType)) && CLMS.Framework.Number.GreaterThan(() => fMapping.InvoiceTypes.length, () => 0)) {continue;}for (let _irow = 0; _irow < (invoice?.InvoiceDetails == null ? 0 : invoice?.InvoiceDetails.length); _irow++) {let row = invoice?.InvoiceDetails[_irow];if (!(fMapping?.VatTypes?.linq?.contains(row?.VatCategory))) {continue;}if (fMapping?.HasSpecificTransactionItemType) {console.info("We are at HasSpecificTransactionItemType!");if (fMapping?.IsAsset && row?.Good?.TransactionItemType == Domain.TransactionItemType.Asset) {relevantInvoicesRows?.add(row);}else if (fMapping?.IsGood && (row?.Good?.TransactionItemType == Domain.TransactionItemType.Good || row?.Good?.TransactionItemType == Domain.TransactionItemType.Other)) {relevantInvoicesRows?.add(row);}else if (fMapping?.IsService && row?.Good?.TransactionItemType == Domain.TransactionItemType.Service) {relevantInvoicesRows?.add(row);}}else {relevantInvoicesRows?.add(row);}}}}
return relevantInvoicesRows;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}